import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { financialGuard } from '../../core/guards/financial/financial.guard';
import { HomeComponent } from './home.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    data: { title: 'Financeiro - Início' },
    canActivate: [financialGuard]
  }
];

export const HomeRoutes: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
